/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-28T14:14:36.558
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'financial-FinancialCollection-'

export default 
{
path: '/financial/financialcollection',
name: 'financial-FinancialCollection',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}FinancialCollection-index',

meta:{
...meta,
title: '实收管理'
},

component: () => import('@/pages/financial/financialcollection/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}FinancialCollection-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '实收管理编辑'
},

component: () => import('@/pages/financial/financialcollection/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}FinancialCollectiondetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '实收管理新增'
},

component: () => import('@/pages/financial/financialcollection/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}FinancialCollectionView',
auth: [
'hidden'
],

meta:{
...meta,
title: '实收管理详情查看'
},

component: () => import('@/pages/financial/financialcollection/detail-view') ,
},
]
};
